<template>
  <div ref="slotRoot">
    <slot :update />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, inject } from 'vue'

const updateCustomFieldsDependency = inject<(string, boolean) => void>(
  'updateCustomFieldsDependency',
)

const slotRoot = ref<HTMLElement | null>(null)
const key = ref<string>('')
const initial = ref<any>('')
const current = ref<any>('')

onMounted(async () => {
  const select = slotRoot.value?.querySelector('select')
  if (select) {
    initial.value = select.value
    current.value = select.value
    key.value = select.name
  }
  const textarea = slotRoot.value?.querySelector('textarea')
  if (textarea) {
    initial.value = textarea.value
    current.value = textarea.value
    key.value = textarea.name
  }
})

const update = (event) => {
  current.value = event?.target?.value
  if (!updateCustomFieldsDependency) return
  updateCustomFieldsDependency(key.value, current.value !== initial.value)
}
</script>
